import api from "../utils/api";
import {useEffect} from "react";
import {useCommonStore} from "./useCommonStore";
import {LanguageMap} from "../constants";

export const useLanguages = () => {
  const {langOptions, setLangOptions} = useCommonStore();

  useEffect(() => {
    const initLanguages = async() => {
      if (!localStorage.getItem('lang')) {
        const browserLang = navigator.language.split('-')[0];
        localStorage.setItem('lang', browserLang);
        if (browserLang !== 'ko') {
          window.location.reload();
        }
      }

      if (langOptions.length === 0) {
        const languages = await api.get('/common/support-languages');
        if (languages) {
          if (languages.includes('ko')) {
            // 한국어를 맨 앞으로 배치
            let sortedLanguage = languages.filter(lang => lang !== 'ko');
            sortedLanguage.unshift('ko');
            setLangOptions(convertLanguageArray(sortedLanguage));
          } else {
            setLangOptions(convertLanguageArray(languages));
          }
        }
      }
    }

    initLanguages();
  }, []);
}

/**
 * @param languages: string[]
 * @returns {[{name: string, value: string}]}
 */
export const convertLanguageArray = (languages) => {
  return languages.map(language => convertLanguage(language));
}

/**
 * @param language: {string}
 * @returns {{name: string, value: string}}
 */
export const convertLanguage = (language) => {
  return {name: LanguageMap[language], value: language}
}